/**
 * @file: 存放cache 或者 通用信息
 */

import { createStore } from 'redux';
import Immutable from 'immutable';
import { FLoadConfig, FMicroEvent, TPlatforms } from '../typings/index';

const initialState = Immutable.Map({
  [TPlatforms.INDUSTRY_PLATFORM]: [] as FLoadConfig[],
  [TPlatforms.SMART_CONTACT_CMS]: [] as FLoadConfig[],
  eventPool: [] as FMicroEvent[],
  mode: '',
});

// 用户微应用的权限信息
function MicroAppInfo(state = initialState, action: any) {
  switch (action.type) {
    case 'SET':
      return state.set(action.payload.path, action.payload.data);
    case 'COMMIT_EVENT':
      return state.set('eventPool', [ ...(state.get('eventPool') as FMicroEvent[] || []), action.payload ])
    default:
      return state
  }
}

const store = createStore(MicroAppInfo);

export const getAllPages = () => {
  return [...(store.getState().get(TPlatforms.INDUSTRY_PLATFORM, []) as FLoadConfig[]), ...(store.getState().get(TPlatforms.SMART_CONTACT_CMS, []) as FLoadConfig[])];
};

export default store;
